import moment from "moment";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";

import { getAPIFilters } from "../../use_filtered_collection/format_filters";

export const useFlattenedAvailabilityFilters = (selectedFilters) => {
  const { formatISODate } = useDateFormatter();

  const DEFAULT_FILTERS = {
    availability: {
      start: formatISODate(),
      end: formatISODate(moment().add(3, "months"))
    }
  };
  const { availability, strings } = getAPIFilters(selectedFilters);
  const apiRequestFilters = {};

  Object.keys(strings || {}).forEach((filterName) => {
    if (filterName !== "profile_id") {
      apiRequestFilters[`pcf_[${filterName}]`] = strings[filterName];
    } else {
      apiRequestFilters[filterName] = strings[filterName];
    }
  });

  apiRequestFilters["availability"] = availability ?? DEFAULT_FILTERS.availability;
  apiRequestFilters["start_date"] =
    availability?.start || availability?.start_date || DEFAULT_FILTERS.availability.start;
  apiRequestFilters["end_date"] =
    availability?.end || availability?.end_date || DEFAULT_FILTERS.availability.end;
  return apiRequestFilters;
};
